import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-finaly-order-total15-days',
  templateUrl: './finaly-order-total15-days.component.html',
  styleUrls: ['./finaly-order-total15-days.component.css'],
})
export class FinalyOrderTotal15DaysComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  loading: boolean = true;
  errorApi: boolean = false;
  inValue: boolean = false;
  message: string = '';
  @Output() errorEmitter = new EventEmitter();

  dataSource = {
    chart: {
      legendposition: 'Right',
      drawanchors: '1',
      showvalues: '1',
      theme: 'gammel',
    },
    data: [
      {
        label: '',
        value: '',
      },
    ],
  };

  constructor(private api: ApiService) {}

  ngOnInit(): void {}

  filterItem(item: any) {
    this.errorApi = false;
    this.loading = true;
    this.getFinalyOrder15Days(item);
  }

  async getFinalyOrder15Days(item: any) {
    this.inValue = false;
    const itemProductAux =
      item.typeProduct != '' ? item.typeProduct : [0, 1, 2, 3];
    if (item.branch == '') {
      this.message = CONSTANTS.MESSAGES.DATA_BRANCH_NULL;
      this.loading = false;
      this.errorApi = true;
      return;
    }
    this.dataSource.data = [
      {
        label: '',
        value: '',
      },
    ];
    try {
      this.dataSource.data = [];
      const result = await this.api
        .getFinalyOrder15Days(itemProductAux, item.branch)
        .toPromise();
      if (result.items.length != 0) {
        this.inValue = true;
        result.items.map((el: any) => {
          this.dataSource.data.push({
            label: el.movementDate.toString(),
            value: el.totalQuantity.toString(),
          });
        });
        this.errorApi = false;
      } else {
        this.message = CONSTANTS.MESSAGES.DATA_NULL_FINALY15;
        this.errorApi = true;
      }
    } catch (ex) {
      this.loading = false;
      this.errorApi = true;
      this.formatErrorMensagem(ex.error[0].message);
    } finally {
      if (!this.inValue) {
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_NULL_FINALY15;
        this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_FINALY15);
      }
      this.loading = false;
    }
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: Finaly-fifteen-days \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }
}
